export function splitCommaSeparatedValues(text: string): string[] {
  return text
    .split(/[,]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function mergeTagValues(current: string[], incoming: string[]): string[] {
  return Array.from(new Set([...current, ...incoming].map((v) => v.trim()).filter(Boolean)));
}
